var map = {
	"./number-1.svg": 691,
	"./number-2.svg": 692,
	"./number-3.svg": 693,
	"./number-4.svg": 694,
	"./number-5.svg": 695,
	"./number-6.svg": 696,
	"./number-7.svg": 697,
	"./number-8.svg": 698,
	"./number-9.svg": 699,
	"./number-shine-1.svg": 700,
	"./number-shine-2.svg": 701,
	"./number-shine-3.svg": 702,
	"./number-shine-4.svg": 703,
	"./number-shine-5.svg": 704,
	"./number-shine-6.svg": 705,
	"./number-shine-7.svg": 706,
	"./number-shine-8.svg": 707,
	"./number-shine-9.svg": 708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;